<app-dropdown   [formControl]="period"
                [label]="label"
                [placeholder]="'All Time'"
                (chosenOption)="changePeriod($event)"
                [isOptionObject]="true"
                [options]="periodsList"
                [isLoading]="isLoading"
                (tabEnterEvent)="tabEnter.next()"
                (dropdownOpened)="dropdownOpened.next()"
                (dropdownClosed)="dropdownClosed.next()"
                #periodDropdown
></app-dropdown>
  
<app-datepicker-input [formControl]="customPeriod"
                    [tabInd]="0"
                    [selectMode]="'range'"
                    [dateMax]="now()"
                    (dateTimeChange)="customPeriodChanged($event)"
                    (afterPickerClosed)="checkDateRangeAfterClosed()"
                    #customPeriodDatepicker
></app-datepicker-input>